import GaugeChartFormatting from './GaugeChartFormatting';
import LabelFormatting from './LabelFormatting';

const ChartFormat = ({ chartType, iconColor, backgroundColor }: any) => {
  return (
    <div className="optionsInfo" style={{ paddingTop: '6px' }}>
      {chartType === 'gauge' ? (
        <GaugeChartFormatting iconColor={iconColor} backgroundColor={backgroundColor} />
      ) : (
        <LabelFormatting
          formatFor="label"
          iconColor={iconColor}
          backgroundColor={backgroundColor}
        />
      )}
    </div>
  );
};

export default ChartFormat;
